<xpo-shell class="main-shell">
  <xpo-header-app-name>Edge</xpo-header-app-name>
  <xpo-header-sub-app-name class="sub-app-container">{{ title }} </xpo-header-sub-app-name>
  <xpo-header-navigation>
    <ng-container *ngFor="let route of userRoutes$ | async; let i = index">
      <button
        *ngIf="!route.children"
        type="button"
        [routerLink]="route.path"
        routerLinkActive="xpo-selected"
        class="menu-button"
      >
        {{ route.label }}
      </button>
      <xpo-header-navigation-dyn-sub-menu *ngIf="route.children" [menuTitle]="route.label">
        <button
          *ngFor="let children of route.children"
          type="button"
          [routerLink]="children.path"
          [attr.routerLink]="children.path"
          routerLinkActive="xpo-selected"
        >
          {{ children.label }}
        </button>
      </xpo-header-navigation-dyn-sub-menu>
    </ng-container>
  </xpo-header-navigation>
  <xpo-header-utilities-actions>
    <button
      mat-icon-button
      (click)="openRamRolesSwitchDialog()"
      *ngIf="!isProduction"
      class="action-btn"
      matTooltip="Switch RAM Roles"
      matTooltipPosition="below"
    >
      <xpo-icon iconName="settings" class="settings-btn"></xpo-icon>
    </button>
    <xpo-auth-user-profile>
      <div class="profile-link"></div>
    </xpo-auth-user-profile>
  </xpo-header-utilities-actions>
  <router-outlet></router-outlet>
  <xpo-app-notification></xpo-app-notification>
</xpo-shell>

<app-footer [buildVersion]="build" (releaseNotes)="releaseNotesSelectedAndOpen()"></app-footer>
